import { useMaterialUIController } from "context";
import React, { useState, useEffect } from "react";

function TimeAgo({ timestamp }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [timeAgo, setTimeAgo] = useState(calculateTimeAgo(timestamp));

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeAgo(calculateTimeAgo(timestamp));
    }, 1000); // Update every 1 second

    return () => {
      clearInterval(intervalId);
    };
  }, [timestamp]);

  function calculateTimeAgo(timestamp) {
    const currentTime = new Date().getTime();
    const timeDifference = (currentTime - timestamp) / 1000; // Convert to seconds

    const minutesAgo = Math.floor(timeDifference / 60);
    const secondsAgo = Math.floor(timeDifference % 60);
    const formattedMinutes = minutesAgo < 10 ? `0${minutesAgo}` : minutesAgo;
    const formattedSeconds = secondsAgo < 10 ? `0${secondsAgo}` : secondsAgo;
    // return `Last updated  ${formattedMinutes}:${formattedSeconds} (MM:SS) ago`;
    return `${formattedMinutes}:${formattedSeconds} (mm:ss) ago`;
  }

  return (
    <div style={darkMode ? { color: "white" } : { color: "black" }}>
      {timeAgo}
    </div>
  );
}

export default TimeAgo;
